export const FEEDBACK_TYPES = Object.freeze({
  BUG_REPORT: 'bug_report',
  CONFUSING_FLOW: 'confusing_flow',
  FEATURE_REQUEST: 'feature_request',
});

export const FEEDBACK_STATUSES = Object.freeze({
  NEW: 'new',
  REVIEWED: 'reviewed',
  ACTIONED: 'actioned',
});
